import type { ServiceClassesTranslationMessages } from './serviceClassesTranslationMessages';

export const serviceClassesLanguageEnglish: ServiceClassesTranslationMessages = {
  service_classes: {
    name: 'Service Classes',
    fields: {
      id: 'ID',
      name: 'Name',
      is_default: 'Default',
      description: 'Description',
      labels: { id: 'Labels', name: 'Labels' },
      office_hours: {
        start_time: 'Start time',
        end_time: 'End time',
        weekday: 'Day of the week',
        weekdays: {
          mo: 'Monday',
          tu: 'Tuesday',
          we: 'Wednesday',
          th: 'Thursday',
          fr: 'Friday',
          sa: 'Saturday',
          su: 'Sunday',
        },
      },
      password_policy: {
        history: 'Password history size',
        lowercase: 'Minimum lowercase characters',
        max_length: 'Maximum length',
        min_length: 'Minimum length',
        numbers: 'Minimum number of digits',
        special: 'Minimum number of special characters',
        uppercase: 'Minimum number of uppercase characters',
      },
      sip_password_policy: {
        history: 'Password history size',
        lowercase: 'Minimum lowercase characters',
        max_length: 'Maximum length',
        min_length: 'Minimum length',
        numbers: 'Minimum number of digits',
        special: 'Minimum number of special characters',
        uppercase: 'Minimum number of uppercase characters',
      },
      users_policy: {
        account_disable_when_idle: 'Disable account when idle',
        account_expires: 'Disable account',
        enforce_mfa: 'Force the use of two-factor authentication',
        password_expires: 'Password expiration',
      },
    },
    operations: {
      create: 'Create service class',
      delete: 'Delete service class',
      edit: 'Edit service class',
      sections: {
        password_policy: 'User Password',
        sip_password_policy: 'SIP Password',
        users_policy: 'User Policies',
        details: 'Details',
        office_hours: 'Office hours',
      },
    },
    helperTexts: {
      users_policy: {
        password_expires: 'Number of days after which password must be changed',
        account_disable_when_idle:
          'Days after which an idle user will be automatically disabled. A value of zero means that the check will not be enabled',
        account_expires: 'Number of days after which account will expire',
        enforce_mfa: 'If enabled, users will need to use two-factor authentication to login',
      },
      password_policy: {
        history:
          'Password history length. Passwords already used last history times will not be accepted on password change / user update operations',
      },
    },
    errors: {
      password_policy: {
        minLength: 'Password must be at least %{minLength} characters long',
        maxLength: 'Password must be at most %{maxLength} characters long',
        minUppercase: 'Password must contain at least %{minUppercase} uppercase characters',
        minLowercase: 'Password must contain at least %{minLowercase} lowercase characters',
        minNumbers: 'Password must contain at least %{minNumbers} numbers',
        minSpecials: 'Password must contain at least %{minSpecials} special characters',
      },
    },
  },
};
